// 获取贷款详情所有数据
export const GET_LOAN_ALL_DATA = 'GET_LOAN_ALL_DATA'

// 设置贷款详情所有数据
export const SET_LOAN_ALL_DATA = 'SET_LOAN_ALL_DATA'

// 贷款详情零散数据
export const GET_LOAN_INFO_DETAIL = 'GET_LOAN_INFO_DETAIL'

// 设置还款计划列表
export const SET_REPAY_INFO_LIST = 'SET_REPAY_INFO_LIST'

// 合同签名
export const SIGN_AGREEMENT = 'SIGN_AGREEMENT'

// 下载合同
export const DOWN_AGREEMENT = 'DOWN_AGREEMENT'

// 更改签名
export const SET_SIGNED = 'SET_SIGNED'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/loanDetail.js